/* eslint-disable no-console */
import { connect, StringCodec, tokenAuthenticator } from "nats.ws";
import { NotificationToggle, screenSharingMsg } from "src/slices/AvToolbar";
import {
  changeState,
  presenterEnabled,
  setCursorPosition,
  // setSnakMsg,
} from "src/slices/editor";
import {
  fetcingLiveServices,
  getAllServices,
  getParticipants,
  participantsUpdate,
  serviceUpdate,
  UpdateGroupVdiGroup,
  UpdateGroupVdiGroupStatus,
  handleMachineStopNotification,
  getGroupData,
  VdiServiceActions,
  handleShowMaxLimitDisclaimer,
} from "src/slices/events/Resource_Assignment";
import {
  updatePublishedQuestions,
  updateQuickAction,
  updateTestCase,
  handleLiveResultResponse,
  handleAssessmentId,
  handleShowLatestResponse,
  clearQuickActions,
  canSelectAnyQuestion,
  handleAssessmentDuration,
  closePublish,
} from "src/slices/gamificationDrawer";
import { messageApiById, fetchDMMessages, markDMAsRead, fetchMyDMThreads, actions as messengerActions } from "src/slices/messenger";
import {
  AccessPermissionActions,
  AccessNotification,
  deviceID,
  devicesUsage,
  NotificationMuteUnmute,
  vdiAccessNotification,
} from "src/slices/myMachines";
import {
  autoAccessSetVDI,
  EventDeleted,
  notifySnackMSG,
  notifyAccessVDIDialog,
  notifyAccessGrantedDialog,
  notifyVdiProgressStage,
  clearVdiProgress,
} from "src/slices/oprations";
import {
  hitWaitingAPI,
  insufficientCreditsDialog,
  storeReaction,
  storeWaitingDialog,
  manageUserReaction,
  participantHandDown,
  setOpenPlanUpgraded,
} from "src/slices/waitingRoom";

import store from "src/store";
import {
  handleRecordingMsg,
  handleSendRecordingFailedMessage,
  notePromptSend,
  recordingStatus,
  setRecordingStatus,
  showRecordingStartedDialog,
  showRecordinStoppedDialog,
} from "src/slices/presenter";
import {
  clearAllDrawerStates,
  handleVideoDisable,
  ParticipantRecordMsg,
  stopScreenShare,
} from "src/slices/meeting";
import {
  removeAccessActiveMachine,
  handleIsCollabAvailable,
} from "src/slices/persistStore";
// ... (imports remain the same)
import { getNatsCredentials } from "src/slices/natsCredentials";
import jwt_decode from "jwt-decode";
import { handleMachineLimitDialog } from "src/slices/networkState";
import { handleMicToggle, leaveRoom } from "src/slices/livekitMeeting";
import UserService from "./UserService";
import { unMuteAllParticipants, roleUpdateParticipant, getParticipantsData } from "src/slices/participants";
import { setSpeakingStatusInParticipants, setTrainerSpeakingStatusInParticipants } from "src/slices/events/Resource_Assignment";
import { audioAction } from "src/slices/waitingAV";
import { meetingActions } from "src/slices/meeting";
import { waitinroomActions } from "src/slices/waitingRoom";
import { setVdiKickTimeout } from "src/slices/oprations";
const connectUrl = process.env.REACT_APP_NATS_URL;

let natsConnected = false;

let natsConnection;
let timerId;
let Dispatch;
let EnqueueSnackbar; // Added to store snackbar reference
let subscriptions = new Map(); // Store subscriptions for cleanup
const sc = StringCodec();

const handleRecordingData = (dispatch, data) => {
  const token = localStorage.getItem("token");
  const tokenData = jwt_decode(token);
  const loggedInEmail = tokenData?.email;
  if (loggedInEmail === "recorder@yopmail.com") {
    if (data?.response?.data?.message) {
      dispatch(handleRecordingMsg(data?.response?.data?.message));
      // eslint-disable-next-line
      console.log("Recording", data?.response?.data?.message);
    } else if (data?.response?.data) {
      dispatch(handleRecordingMsg(data?.response?.data));
      // eslint-disable-next-line
      console.log("Recording", data?.response?.data);
    }
  }
};

// Internal function to handle incoming messages
async function handleNatsMessage(msg) {

  if (!Dispatch) return; // Cannot process without dispatch

  try {
    const messageStr = sc.decode(msg.data);
    const data = JSON.parse(messageStr);
    const dispatch = Dispatch;
    const enqueueSnackbar = EnqueueSnackbar; // Use stored enqueueSnackbar
    const isPlaybook = store.getState().AVSetting.eventType === "playbook";

    // Skip messages that have an eventId not matching the current event
    if (data.eventId) {
      const currentEventId = window.location.href.split("/")[4]?.split("?")[0];
      if (currentEventId && data.eventId !== currentEventId) {
        console.log("Skipped NATS message from different event:", data, currentEventId);
        return;
      }
    }


    if (data.type === "BILLING" && data.action === "INSUFFICIENT_CREDITS") {
      const feature = data?.data?.feature || "AI Assistant";
      const token = localStorage.getItem("token");
      const tokenData = token ? jwt_decode(token) : null;
      const loggedInEmail = tokenData?.email;
      const ownerEmail = data?.data?.email;
      const isOwner = loggedInEmail === ownerEmail;

      if (isOwner || !ownerEmail) {
        dispatch(waitinroomActions.storeInsufficientCredits({
          active: true,
          message: "Insufficient AI Credits",
          serviceName: feature,
        }));
      } else if (enqueueSnackbar) {
        enqueueSnackbar(`The event owner has insufficient AI credits left to use ${feature}.`, {
          variant: "info",
          preventDuplicate: true,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 5000,
        });
      }
      return;
    }

    // Handle Playbook events
    if (data?.action) {
      switch (data.action) {
        case "clear_question_dialogue":
          dispatch(closePublish());
          break;
        case "screen_unshare":
          dispatch(meetingActions.setPlaybookScreenShare(false));
          break;
        case "screen_share":
        case "start":
        case "resume": {
          dispatch(meetingActions.setPlaybookScreenShare(true));
          const trainerOnStart = store.getState().resourceAllocation?.participants?.find(
            (p) => p?.role?.name === "Trainer"
          );
          if (trainerOnStart) {
            dispatch(setTrainerSpeakingStatusInParticipants({
              participant_id: trainerOnStart.id,
              type: "start",
            }));
          }
          break;
        }
        case "pause": {
          dispatch(meetingActions.setPlaybookScreenShare(false));
          const trainerOnPause = store.getState().resourceAllocation?.participants?.find(
            (p) => p?.role?.name === "Trainer"
          );
          if (trainerOnPause) {
            dispatch(setTrainerSpeakingStatusInParticipants({
              participant_id: trainerOnPause.id,
              type: "pause",
            }));
          }
          break;
        }
        case "speaking":
          if (data?.data) {
            dispatch(setSpeakingStatusInParticipants(data.data));
          }
          break;
        case "playbook_completed":
          dispatch(waitinroomActions.setPlaybookCompletedVP(true));
          break;
        case "playbook_corrupt":
          dispatch(waitinroomActions.setPlaybookCorrupt(true));
          break;
        case "kick_participant":
          if (data?.data?.timeout) {
            dispatch(setVdiKickTimeout(data.data.timeout));
          }
          break;
        case "vdi_operation": {
          if (isPlaybook) {
            const currentState = data?.data?.currentState;
            const serviceId = data?.data?.serviceId;
            const status = data?.data?.status;

            if (status === "failed" && currentState?.toUpperCase() === "INVESTIGATION") {
              dispatch(notifyVdiProgressStage({ serviceId, stage: "INVESTIGATION", mode: "error" }));
            } else if (data?.data?.operation === "start") {
              const startStages = ["REGISTERED", "INITIATED", "PROVISIONING", "VALIDATING"];
              if (currentState === "STARTED") {
                dispatch(clearVdiProgress());
              } else if (startStages.includes(currentState)) {
                dispatch(notifyVdiProgressStage({ serviceId, stage: currentState, mode: "start" }));
              }
            } else if (data?.data?.operation === "archive") {
              const archiveStages = ["ARCHIVING", "VALIDATING"];
              if (currentState === "ARCHIVED") {
                dispatch(clearVdiProgress());
              } else if (archiveStages.includes(currentState)) {
                dispatch(notifyVdiProgressStage({ serviceId, stage: currentState, mode: "archive" }));
              }
            } else if (data?.data?.operation === "retrieve") {
              const retrieveStages = ["RETRIEVING", "VALIDATING"];
              if (currentState === "STARTED") {
                dispatch(clearVdiProgress());
              } else if (retrieveStages.includes(currentState)) {
                dispatch(notifyVdiProgressStage({ serviceId, stage: currentState, mode: "retrieve" }));
              }
            } else if (data?.data?.operation === "upgrade") {
              const upgradeStages = ["RESIZING", "VALIDATING"];
              if (currentState === "STARTED") {
                dispatch(clearVdiProgress());
              } else if (upgradeStages.includes(currentState)) {
                dispatch(notifyVdiProgressStage({ serviceId, stage: currentState, mode: "upgrade" }));
              }
            } else if (data?.data?.operation === "stop") {
              const stopStages = ["STOPPING", "VALIDATING"];
              dispatch(changeState(false));
              if (currentState === "STOPPED") {
                dispatch(notifyVdiProgressStage({ serviceId, stage: currentState, mode: "stop" }));
                setTimeout(() => dispatch(clearVdiProgress()), 2000);
              } else if (stopStages.includes(currentState)) {
                dispatch(notifyVdiProgressStage({ serviceId, stage: currentState, mode: "stop" }));
              }
            }
          }
          break;
        }
        case "agent_joined":
          dispatch(meetingActions.setAgentJoined(true));
          break;
        case "low_ai_credits":
          dispatch(waitinroomActions.storeInsufficientCredits({
            active: true,
            message: "You do not have enough AI credits to start this playbook. Please add more AI credits and try joining the playbook again.",
            serviceName: "playbook",
          }));
          break;
        case "host_low_ai_credits":
          dispatch(waitinroomActions.storeInsufficientCredits({
            active: true,
            message: "The host does not have enough AI credits to start this playbook. We've already notified the host. Please try joining again later.",
            serviceName: "playbook-participant",
          }));
          break;
        default:
          break;
      }
    }

    // for development only
    if (process.env.REACT_APP_MODE === "DEVELOPMENT") {
      // eslint-disable-next-line
      if (data.domain && data.intent) {
        console.log(
          `[NATS] ${data.domain} | ${data.intent}`,
          data,
        );
      } else {
        console.log("NATS MESSAGE RECEIVED:", data);
      }
    }

    if (data.domain === "PARTICIPANT") {
      if (data.intent === "NOTIFY_ACCESS_VDI") {
        dispatch(getAllServices());
        dispatch(notifySnackMSG(data));
      } else if (data.intent === "AUTO_ACCESS") {
        dispatch(removeAccessActiveMachine());
        dispatch(
          autoAccessSetVDI(data, store.getState().persistStore.activeMachine),
        );
      } else if (data.intent === "PARTICIPANT_LEFT") {
        dispatch(getParticipants());
        dispatch(getParticipantsData());
      } else if (data.intent === "PARTICIPANT_JOIN") {
        dispatch(getParticipants());
        dispatch(getParticipantsData());
      } else if (data.intent === "ROLE_UPDATE_REFRESH") {
        // This setTimeout is for allowed permission takes a while to get the latest permission
        setTimeout(() => {
          dispatch(ParticipantRecordMsg(enqueueSnackbar, data));
        }, 2000);
      } else if (data.intent === "ROLE_UPGRADE_DOWNGRADE") {
        dispatch(clearAllDrawerStates(data));
        dispatch(getAllServices());
        dispatch(getParticipants());
        dispatch(getParticipantsData());
      } else if (data.intent === "RAISE_HAND" && data?.response?.show) {
        dispatch(storeReaction(data, true));
      } else if (data.intent === "DOWN_HAND") {
        dispatch(storeReaction(data, false));
        dispatch(participantHandDown(data));
      } else if (data.intent === "REACTION") {
        dispatch(manageUserReaction(data));
      } else if (data.intent === "PARTICIPANT_REMOVE") {
        // const dataRemove = {
        //   userName: store.getState().livekitMeeting.localParticipant.name,
        //   id: store.getState().events.threadId,
        // };
        // dispatch(leftMessages(dataRemove));
        dispatch(leaveRoom());

      } else {
        dispatch(storeWaitingDialog(data));
      }
    } else if (data.domain === "GAMIFICATION") {
      if (data.response?.data?.questions) {
        const questions = data.response?.data?.questions;
        if (data?.response?.data?.type === "flexible") {
          dispatch(canSelectAnyQuestion(false));
        } else if (data?.response?.data?.type === "exam") {
          dispatch(closePublish());
          dispatch(
            handleAssessmentDuration(data?.response?.data?.duration * 60),
          );
          dispatch(canSelectAnyQuestion(true));
        }
        dispatch(handleAssessmentId(data?.response?.data?.id));
        let isQuick = false;
        for (const question of questions) {
          if (question?.type === "quick") {
            isQuick = true;
            dispatch(updateQuickAction(data));
          } else if (question?.type === "code") {
            dispatch(updateTestCase(question?.id, question?.test_cases));
          }
        }
        if (!isQuick) {
          dispatch(updatePublishedQuestions(data));
        }
      }
      if (data.intent === "SUBMISSION_UPDATE") {
        dispatch(handleShowLatestResponse({}));
        if (data.response?.data?.data?.type === "quick") {
          dispatch(handleShowLatestResponse(data.response?.data?.data));
          dispatch(handleLiveResultResponse(data.response?.data?.data));
        } else {
          dispatch(handleShowLatestResponse(data.response?.data));
          dispatch(handleLiveResultResponse(data.response?.data));
        }
        if (timerId) {
          clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
          dispatch(handleShowLatestResponse({}));
        }, 7000);
      } else if (data.intent === "QUESTION_PREEMPT") {
        dispatch(clearQuickActions(data));
      }
    } else if (data.domain === "CONFERENCE") {
      if (data.intent === "SCREENSHARING") {
        dispatch(screenSharingMsg(data));
      } else if (data.intent === "SCREENSHARINGSTOP") {
        const roomData = store.getState().meeting.room;
        dispatch(stopScreenShare(roomData));
      } else if (data.intent === "MIC_UPDATE") {
        const room = store.getState()?.livekitMeeting?.room;
        const localParticipant = room.localParticipant;
        if (localParticipant.isMicrophoneEnabled) {
          dispatch(handleMicToggle(enqueueSnackbar));
          dispatch(audioAction(!localParticipant.isMicrophoneEnabled));
          dispatch(
            NotificationMuteUnmute(
              data.response.data.action,
              data.response.data.message,
            ),
          );
        }
      } else if (data.intent === "NOTE_RECEIVED") {
        dispatch(notePromptSend(true, data.response.data.note, data.response.data.message));
      } else if (data.intent === "RECORDING_STARTED") {
        dispatch(showRecordingStartedDialog(true));
        dispatch(showRecordinStoppedDialog(false));
        dispatch(setRecordingStatus("started"));
        dispatch(recordingStatus(true));
        const token = localStorage.getItem("token");
        const tokenData = jwt_decode(token);
        const loggedInEmail = tokenData?.email;
        if (loggedInEmail !== "recorder@yopmail.com") {
          console.log("STARTED payload", data);
          dispatch(meetingActions.setRecordingStartedBy(data?.response?.data));
        }
        handleRecordingData(dispatch, data);
      } else if (data.intent === "MACHINE_REQUEST") {
        dispatch(
          AccessPermissionActions.setMachineRequestDialog({
            open: true,
            data: data?.response?.data,
          }),
        );
      } else if (data.intent === "RECORDING_ENDED") {
        dispatch(showRecordingStartedDialog(false));
        dispatch(showRecordinStoppedDialog(true));
        const token = localStorage.getItem("token");
        const tokenData = jwt_decode(token);
        const loggedInEmail = tokenData?.email;
        if (loggedInEmail !== "recorder@yopmail.com") {
          dispatch(recordingStatus(false));
          dispatch(setRecordingStatus("ended"));
          dispatch(meetingActions.setRecordingStartedBy(data.response.data));
          dispatch(meetingActions.setRecordingStarted(true));
        }
        handleRecordingData(dispatch, data);
      } else if (data.intent === "RECORDING_READY") {
        dispatch(meetingActions.setRecordingStarted(false));
        dispatch(setRecordingStatus("ended"));
      } else if (data.intent === "RECORDING_REQUESTED") {
        dispatch(setRecordingStatus("starting"));
        const token = localStorage.getItem("token");
        const tokenData = jwt_decode(token);
        const loggedInEmail = tokenData?.email;
        if (loggedInEmail !== "recorder@yopmail.com" && data?.response?.data?.message) {
          // dispatch(handleRecordingMsg(data.response.data.message));
        }
        handleRecordingData(dispatch, data);
      } else if (data.intent === "REQUESTED_STOP_RECORDING") {
        const token = localStorage.getItem("token");
        const tokenData = jwt_decode(token);
        const loggedInEmail = tokenData?.email;
        if (loggedInEmail !== "recorder@yopmail.com") {
          dispatch(setRecordingStatus("stopping"));
          // if (data?.response?.data?.message) {
          //   dispatch(handleRecordingMsg(data.response.data.message));
          // }
        }
        handleRecordingData(dispatch, data);
      } else if (data.intent === "RECORDING_FAILED") {
        handleRecordingData(dispatch, data);
        dispatch(
          handleSendRecordingFailedMessage(
            "Recording failed. Please try again.",
          ),
        );
        dispatch(setRecordingStatus("ended"));
        dispatch(recordingStatus(false));
      } else if (data.intent === "PARTICIPANT_REMOVE") {
        dispatch(EventDeleted(true));
      } else if (data.intent === "COLLABORATION_ENABLED") {
        dispatch(handleIsCollabAvailable(true));
      } else if (data.intent === "COLLABORATION_DISABLED") {
        dispatch(handleIsCollabAvailable(false));
      } else if (data.intent === "VIDEO_DISABLED") {
        dispatch(handleVideoDisable(enqueueSnackbar));
        UserService.refreshOnce(dispatch);
      } else if (data.intent === "VIDEO_ENABLED") {
        UserService.refreshOnce(dispatch);
      } else if (data.intent === "END_CALL") {
        // const dataRemove = {
        //   userName: store.getState().meeting.userName,
        //   id: store.getState().events.threadId,
        //   roomInstance: store.getState().meeting.room.roomInstance,
        //   localTracks: store.getState().meeting.room.localTracks,
        //   room: store.getState().meeting.room,
        // };
        // dispatch(leftMessages(dataRemove));
        dispatch(leaveRoom());
      } else if (data.intent === "LICENSE_UPGRADED") {
        dispatch(setOpenPlanUpgraded(true));
      } else if (data.intent === "ASK_TO_UNMUTE") {
        dispatch(unMuteAllParticipants(data?.response?.data?.message));
      } else if (data.intent === "ROLE_CHANGE") {
        dispatch(roleUpdateParticipant(data?.response));
      }
    } else if (data.domain === "GROUP") {
      if (data.intent === "GROUP_INCREASE") {
        dispatch(UpdateGroupVdiGroup(data));
      }
    } else if (data.domain === "SERVICE") {
      if (data.intent === "LIFECYCLE_UPDATE") {
        dispatch(serviceUpdate(data));
        const lifecycleState = data.response.data.state;
        const lifecycleServiceId = data.response.data.serviceId;
        if (isPlaybook) {
          const midStartupStates = ["INITIATED", "PROVISIONING", "VALIDATING", "CONFIGURING", "STARTING"];
          const isMidStartup = midStartupStates.includes(lifecycleState);

          if (lifecycleState === "STARTED") {
            dispatch(clearVdiProgress());
          } else if (lifecycleState === "INVESTIGATION") {
            dispatch(notifyVdiProgressStage({ serviceId: lifecycleServiceId, stage: lifecycleState, mode: "error" }));
          } else if (isMidStartup) {
            const existingMode = store.getState().oprations.vdiProgressDialog.mode || "start";
            dispatch(notifyVdiProgressStage({ serviceId: lifecycleServiceId, stage: lifecycleState, mode: existingMode }));
          }
        }
        if (lifecycleState === "STARTED") {
          if (
            data.response.data.serviceId ===
            store.getState().accessPermissionDialog.ID
          ) {
            dispatch(deviceID(data.response.data.serviceId, true));
          }
          dispatch(notifyAccessVDIDialog(data));
        }
        dispatch(
          AccessNotification(
            data,
            store.getState().persistStore.activeMachine,
            store.getState().editor.vdiInfoRead,
            store.getState().accessPermissionDialog.ID,
          ),
        );
        if (data.response.data.state === "RESIZING") {
          dispatch(UpdateGroupVdiGroupStatus(data));
        }
        if (
          data?.response?.data.state === "STOPPING" ||
          data?.response?.data?.state === "STOPPED"
        ) {
          dispatch(handleMachineStopNotification(data?.response?.data));
        }
        if (data?.response?.data?.state === "DESTROYED") {
          dispatch(getGroupData(store.getState().AVSetting.currentGroupId));
        }
      } else if (data.intent === "SERVICE_OPERATION") {
        dispatch(handleMachineStopNotification(data?.response?.data));
      } else if (data.intent === "ACCESS_UPDATE") {
        if (data?.response?.data?.action === "ACCESS_REVOKED" && data?.origin === "playbook") {
          dispatch(changeState(false));
        }
        dispatch(presenterEnabled(data, store.getState().persistStore));
        dispatch(getParticipants());
        dispatch(getParticipantsData());
        dispatch(getAllServices());
        dispatch(
          AccessNotification(
            data,
            store.getState().persistStore.activeMachine,
            store.getState().editor.vdiInfoRead,
            store.getState().accessPermissionDialog.ID,
          ),
        );
        dispatch(
          fetcingLiveServices(data, store.getState().AVSetting.currentGroupId),
        );
        if (data?.response?.data?.action === "ACCESS_GRANTED") {
          dispatch(notifyAccessGrantedDialog(data));
        }
      } else if (data.intent === "PRESENTOR_VDI_UPDATED") {
        // Moved the logic of vdi sharing using yjs instead of mqtt
        // dispatch(getVDIPresenter(data));
        // dispatch(setSnakMsg(true, data));
      } else if (data.intent === "PRESENTOR_VDI_REMOVED") {
        // Moved the logic of vdi sharing using yjs instead of mqtt
        // dispatch(removePresenterAccessUpdate());
        // dispatch(setSnakMsg(false, data));
      } else if (data.intent === "LOCK") {
        dispatch(participantsUpdate(data));
      } else if (data.intent === "SERVICE_INCREASE") {
        dispatch(getAllServices());
        dispatch(
          fetcingLiveServices(data, store.getState().AVSetting.currentGroupId),
        );
      } else if (data.intent === "DEVICE_USGAE") {
        dispatch(devicesUsage(data));
      } else if (data.intent === "ACCESS_NOTIFY") {
        dispatch(vdiAccessNotification(data?.response?.data?.message));
      } else if (data.intent === "SERVER_DEPLOYMENT_FAILURE") {
        if (!isPlaybook) {
          dispatch(handleMachineLimitDialog());
        }
      } else if (
        data.intent === "CREDIT_LIMIT_REACHED" ||
        data.intent === "INSTANCE_LIMIT_REACHED" ||
        data.intent === "INSTANCE_COST_LIMIT_REACHED" ||
        data.intent === "INSTANCE_AND_CREDIT_LIMIT_REACHED"
      ) {
        
        const userType = data?.response?.data?.user || data?.user;
        let properMsg = data?.response?.data?.message || data?.message || "";
        if (isPlaybook) {
          dispatch(
            notifyVdiProgressStage({
              active: true,
              mode: "credits_limit",
              serviceId: data?.serviceId || data?.response?.data?.serviceId || "",
              stage: "LIMIT_REACHED",
            })
          );
        } else {
          if (userType === "creator") {
            const isLimit = data.intent === "INSTANCE_LIMIT_REACHED";
            dispatch(VdiServiceActions.disclaimerType(isLimit ? "limit" : "credits"));
            dispatch(VdiServiceActions.maxLimitMessage(properMsg));
            dispatch(VdiServiceActions.limitIntent(data.intent));
            dispatch(handleShowMaxLimitDisclaimer(true));
          } else if (userType === "participant") {
            if (!properMsg) {
              if (data.intent === "INSTANCE_LIMIT_REACHED") {
                properMsg = "It seems you've reached the instance limit for your current plan. To continue hosting meetings without interruptions, we recommend upgrading your plan to unlock additional instances. Upgrade now to ensure seamless collaboration and productivity.";
              } else {
                properMsg = "You have insufficient balance in your account to clone this machine. Kindly add credits to your account by visiting your profile and navigating to the billing section.";
              }
            }
            enqueueSnackbar(properMsg, {
              variant: "info",
              preventDuplicate: true,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              autoHideDuration: 5000,
            });
          }
        }
      }
    } else if (data.domain === "MESSAGING") {
      if (data.intent === "INSUFFICIENT_CREDITS_WITH_REFILL") {
        dispatch(insufficientCreditsDialog(data));
      }
    } else if (data.domain === "COLLAB_POINTER") {
      if (data.intent === "UPDATE") {
        dispatch(setCursorPosition(data?.response));
      }
    } else if (data.domain === "BILLING") {
      if (data.intent === "INSUFFICIENT_CREDITS") {
        const feature = data?.data?.feature || "this feature";
        const token = localStorage.getItem("token");
        const tokenData = token ? jwt_decode(token) : null;
        const loggedInEmail = tokenData?.email;
        const ownerEmail = data?.data?.email;
        const isOwner = loggedInEmail === ownerEmail;

        if (isOwner || !ownerEmail) {
          dispatch(waitinroomActions.storeInsufficientCredits({
            active: true,
            message: "Insufficient Credits",
            serviceName: feature,
          }));
        } else {
          enqueueSnackbar(`The event owner has insufficient AI credits left to use ${feature}.`, {
            variant: "info",
            preventDuplicate: true,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 5000,
          });
        }
      }
    } // end domain checks

    // ── DM message handling ────────────────────────────────────────────────────
    if (data.chatType === "dm" && data.dmThreadId) {
      const state = store.getState().messages;
      const activeDmThreadId = state.dmThreadId;
      const isOnActiveDmThread = activeDmThreadId && String(activeDmThreadId) === String(data.dmThreadId);

      const currentUserId = state.user_id;
      const senderIsMe = data.senderParticipantId === currentUserId || data.userId === currentUserId;

      let peerId = data.senderParticipantId;
      if (senderIsMe && isOnActiveDmThread && state.dmPeer) {
        peerId = state.dmPeer.id;
      }

      if (isOnActiveDmThread) {
        dispatch(fetchDMMessages(data.dmThreadId));
        if (state.dmPeer?.id) {
          dispatch(markDMAsRead(String(data.dmThreadId), state.dmPeer.id, currentUserId));
        }
      } else if (!senderIsMe && peerId) {
        dispatch(messengerActions.markDmUnread(peerId));
      }

      if (peerId) {
        const currentCount = state.dmUnreadCounts?.[peerId] || 0;
        let newCount = currentCount;
        let updatedLastMessage = state.dmPreviews?.[peerId];

        const isEmojiEvent = !!data.emojiCode;
        const isDeleteEvent = data.eventType === "delete_message";

        if (isDeleteEvent) {
          const contextId = data.contextId || window.location.href.split("/")[4]?.split("?")[0];
          dispatch(fetchMyDMThreads(currentUserId, contextId));
          return;
        }

        if (isEmojiEvent) {
          updatedLastMessage = {
            isReaction: true,
            emojiCode: data.emojiCode,
            userId: data.userId || data.senderParticipantId
          };
        } else {
          if (!senderIsMe && !isOnActiveDmThread) {
            newCount = currentCount + 1;
          }
          updatedLastMessage = {
            content: data.content,
            contentType: data.contentType,
            createdBy: data.createdBy,
          };
        }

        dispatch(messengerActions.setDmUnreadCount({
          peerId,
          count: newCount,
          lastMessage: updatedLastMessage
        }));
      }

      dispatch(NotificationToggle());
      return;
    }

    if (data.chatType === "dm_closed" && data.dmThreadId) {
      const activeDmThreadId = store.getState().messages.dmThreadId;
      if (String(activeDmThreadId) === String(data.dmThreadId)) {
        dispatch(messengerActions.addDmClosedBy(data.closedBy));
      }
      return;
    }

    if (data.chatType === "dm_reopened" && data.dmThreadId) {
      const activeDmThreadId = store.getState().messages.dmThreadId;
      if (String(activeDmThreadId) === String(data.dmThreadId)) {
        dispatch(messengerActions.removeDmClosedBy(data.reopenedBy));
      }
      return;
    }
    // ──────────────────────────────────────────────────────────────────────────

    if (
      data.eventType === "event_message" ||
      data.eventType === "join_message" ||
      data.eventType === "left_message" ||
      data.eventType === "delete_message" ||
      !!data.userId
    ) {
      dispatch(messageApiById(store.getState().events.threadId));
      dispatch(NotificationToggle());
      dispatch(getParticipants());
      dispatch(getParticipantsData());
    }
  } catch (err) {
    console.error("Error processing NATS message:", err);
  }
}

async function getClient(data, dispatch, VIEW_ALL_PARTICIPANT) {
  try {
    const jwt = localStorage.getItem("token");
    const dataJwt = jwt_decode(jwt);
    const eventId = window.location.href.split("/")[4];
    const participantId = dataJwt?.sub;

    natsConnection = await connect({
      servers: [connectUrl],
      authenticator: tokenAuthenticator(jwt),
      name: `${eventId}-${participantId}`,
      debug: false, // Silenced protocol logs
      timeout: 30000,
      reconnect: true,
      maxReconnectAttempts: -1,
    });

    // Subscribe to all allowed topics
    const subscriptionPromises = data.allowedSubscriptions.map(
      async (topic) => {
        try {
          const sub = natsConnection.subscribe(topic);
          subscriptions.set(topic, sub);

          // Start processing messages in the background
          (async () => {
            for await (const msg of sub) {
              await handleNatsMessage(msg);
            }
          })();

          return true;
        } catch (err) {
          console.error(`Failed to subscribe to ${topic}:`, err);
          throw new Error(err);
        }
      },
    );

    await Promise.all(subscriptionPromises);

    natsConnected = true;
    dispatch(hitWaitingAPI(VIEW_ALL_PARTICIPANT));

    // for development only
    if (process.env.REACT_APP_MODE === "DEVELOPMENT") {
      //eslint-disable-next-line
      console.log("NATS connected");
    }
  } catch (err) {
    console.error("NATS connection error:", err);
    natsConnected = false;

    // Attempt reconnection
    if (process.env.REACT_APP_MODE === "DEVELOPMENT") {
      //eslint-disable-next-line
      console.log("Reconnecting...");
    }

    setTimeout(() => {
      if (Dispatch) {
        closeConnection();
        Dispatch(getNatsCredentials());
      }
    }, 1000);
  }
}

function getConnectionstatus() {
  return natsConnected;
}

function publish(subject, msg) {
  if (natsConnection && natsConnected) {
    try {
      const payload =
        typeof msg === "string"
          ? sc.encode(msg)
          : sc.encode(JSON.stringify(msg));
      natsConnection.publish(subject, payload);
    } catch (error) {
      console.error("Error publishing to NATS:", error);
      throw new Error(error);
    }
  }
}

const kvBuckets = new Map();

async function getKVBucket(bucketName, ttl = 60000) {
  if (kvBuckets.has(bucketName)) {
    return kvBuckets.get(bucketName);
  }
  const js = natsConnection.jetstream();
  try {
    const kv = await js.views.kv(bucketName);
    kvBuckets.set(bucketName, kv);
    return kv;
  } catch {
    const kv = await js.views.kv(bucketName, { history: 10, ttl });
    kvBuckets.set(bucketName, kv);
    return kv;
  }
}

async function kvPut(bucketName, key, value, ttl = 60000) {
  if (!natsConnection || !natsConnected) {
    console.warn("kvPut: NATS not connected");
    return;
  }
  try {
    const kv = await getKVBucket(bucketName, ttl);
    await kv.put(key, sc.encode(String(value)));
  } catch (error) {
    console.error("kvPut error:", error);
    throw error;
  }
}

// Just sets the dispatch and global listeners reference logic
function onMessage(dispatch, enqueueSnackbar) {
  if (dispatch) Dispatch = dispatch;
  if (enqueueSnackbar) EnqueueSnackbar = enqueueSnackbar;
}

function unsubscribe(subject) {
  const sub = subscriptions.get(subject);
  if (sub) {
    sub.unsubscribe();
    subscriptions.delete(subject);
  }
}

async function closeConnection() {
  if (natsConnection) {
    try {
      // Unsubscribe from all subscriptions
      subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
      subscriptions.clear();

      await natsConnection.close();
      natsConnected = false;
    } catch (err) {
      console.error("Error closing NATS connection:", err);
    }
  }
}

async function natsSubscribe(subject) {
  if (natsConnection && natsConnected) {
    try {
      const sub = natsConnection.subscribe(subject);
      subscriptions.set(subject, sub);

      // Start processing messages
      (async () => {
        for await (const msg of sub) {
          await handleNatsMessage(msg);
        }
      })();
    } catch (error) {
      console.error(`Error subscribing to ${subject}:`, error);
      throw new Error(error);
    }
  }
}

const natsService = {
  getClient,
  getConnectionstatus,
  publish,
  kvPut,
  onMessage,
  natsSubscribe,
  unsubscribe,
  closeConnection,
};

export default natsService;
